import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import GeneralButton from "../common/GeneralButton";
import { TiPlus } from "react-icons/ti";
import "./homePartial.css";
import bg from "../../assets/images/promoImageBg.png";
function PromoSlider({ slides }) {
  const defaultValue = [
    {
      headingColor: "#000",
      heading: "Happy Meals Guaranteed",
      buttonColor: "#000",
      buttonTextColor: "#fff",
      buttonLink: "/plans",
      buttonText: "Get Started",
      backgroundColor: "#CC9965",
    },
  ];
  const filteredSlides = slides && slides.length > 0 ? slides : defaultValue;
  const getHeadingClass = (text) => {
    if (!text) return "text-4xl leading-8"; // default fallback
    if (text.length > 50)
      return "text-3xl lg:text-5xl xl:text-[45px] leading-8";
    if (text.length > 30)
      return "text-4xl lg:text-5xl xl:text-[48px] leading-8";
    return "text-5xl lg:text-6xl leading-8";
  };

  return (
    <div className="relative lg:h-[470px]">
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        loop={filteredSlides.length > 2}
        autoHeight={true}
        autoplay={{
          delay: 15000, // ✅ time between slides (ms)
          disableOnInteraction: false, // ✅ keeps autoplay after user swipes
        }}
        className="rounded-2xl overflow-hidden shadow-md promo-swiper"
      >
        {filteredSlides
          .sort((a, b) => a.sortOrder - b.sortOrder)
          .map((slide, index) => (
            <SwiperSlide key={index}>
              <div
                className="rounded-2xl"
                style={{ backgroundColor: slide.backgroundColor }}
              >
                {/* Desktop layout */}
                <div className="hidden lg:grid grid-cols-2 items-center lg:h-[470px] relative">
                  <div className="flex flex-col items-start justify-center gap-4 2.5xl:px-20 lg:px-12 px-20 relative z-10">
                    <h2
                      className={` ${getHeadingClass(
                        slide.heading
                      )}  capitalize`}
                      style={{
                        color: slide.headingColor,
                        textShadow: "-4px -1px 0px #FFFFFF",
                      }}
                    >
                      {slide.heading}
                    </h2>

                    <GeneralButton
                      text={slide.buttonText}
                      className="ms-1 text-24pt"
                      icon={<TiPlus size={15} />}
                      onClick={() => (window.location.href = slide.buttonLink)}
                      bgColor={slide.buttonColor}
                      // textColor={slide.buttonTextColor}
                    />
                  </div>

                  <div className="relative h-full">
                    <div className="my-shape  lg:w-[140%] xl:w-[120%] 2xl:w-[117%] 2.5xl:w-[124%] 3xl:w-[122%]   2xl:-right-[22%] 3xl:-right-[19%]">
                      <img
                        src={
                          slide?.image
                            ? process.env.REACT_APP_BACKEND_URL +
                              "public/" +
                              slide.image
                            : require("../../assets/images/promo1.png")
                        }
                        style={{ top: "84px", left: 0 }}
                        className="w-[80%] 1xl:w-[85%] h-[471px] absolute"
                      />
                    </div>
                    {/* Top Image Circle */}
                    <img
                      src={bg}
                      style={{ right: "-100px", scale: "1.5" }}
                      className="hidden xl:flex w-full h-full absolute"
                    />
                  </div>
                </div>

                {/* Mobile layout */}
                <div className={`relative lg:hidden   w-full  `}>
                  <img
                    src={
                      slide?.image
                        ? process.env.REACT_APP_BACKEND_URL +
                          "public/" +
                          slide.image
                        : require("../../assets/images/promo1.png")
                    }
                    onError={(e) => {
                      e.currentTarget.src = require("../../assets/images/link.png");
                    }}
                    className="w-full h-[330px] md:h-[450px] object-cover rounded-2xl"
                  />
                  <div
                    style={{ backgroundColor: slide.backgroundColor }}
                    className={`flex flex-col  items-center justify-center ${
                      slide.backgroundColor
                    } rounded-2xl px-4 py-3 h-full ${
                      filteredSlides.length > 1 ? `-translate-y-[50px] ` : "-translate-y-[30px] md:-translate-y-[50px] "
                    }`}
                  >
                    <div
                      className={
                        filteredSlides.length > 1
                          ? "flex flex-col translate-y-[20px] items-center justify-center"
                          : "flex flex-col  mt-6 items-center justify-center"
                      }
                    >
                      <h2
                        className="text-[48px] xs:text-52pt leading-none text-center capitalize "
                        style={{
                          color: slide.headingColor,
                          textShadow: "-5px -2px 0px #FFFFFF",
                        }}
                      >
                        {slide.heading}
                      </h2>
                      <GeneralButton
                        text={slide.buttonText}
                        bgColor={slide.buttonColor}
                        textColor={slide.buttonTextColor}
                        icon={<TiPlus size={15} />}
                        onClick={() =>
                          (window.location.href = slide.buttonLink)
                        }
                        className="mt-4 text-24pt"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
}

export default PromoSlider;
